export default "__VITE_PUBLIC_ASSET__0b88ac8c__"